export default __webpack_public_path__ + "static/media/616.729d7392.png";